<template>
  <b-col :tag="tag" class="p-0" :class="customClass">
    {{ label }}
    <span class="text-danger" v-if="'required' in rules && showRequired"
      >* &nbsp;</span
    >
    <span class="text-danger" v-if="'requiredIf' in rules && showRequired"
      >* &nbsp;</span
    >
    <span v-if="showInfo" v-b-tooltip.hover :title="titleText"
      ><i class="fa fa-lg fa-info-circle text-info"></i
    ></span>
  </b-col>
</template>

<script>
export default {
  props: {
    label: String,
    rules: Object,
    showInfo: {
      type: Boolean,
      default: false,
    },
    showRequired: {
      type: Boolean,
      default: true,
    },
    titleText: {
      type: String,
      default: "",
    },
    tag: {
      type: String,
      default: "div",
    },
    customClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    minLabel() {
      return `[ طول حداقل ${this.rules.minLength.min}]`;
    },
    maxLabel() {
      return `[طول حداکثر ${this.rules.maxLength.max}]`;
    },
    minMaxLabel() {
      if (this.rules.minLength.min == this.rules.maxLength.max) {
        return `[ طول دقیقا ${this.rules.maxLength.max}]`;
      } else {
        return `[ طول بین ${this.rules.minLength.min} و ${this.rules.maxLength.max}]`;
      }
    },
  },
};
</script>

<style>
/* .circle{
   width: 20px;
    height: 20px;
    border-radius: 50%;
    position: absolute;
    margin: 1px 5px;
     border:1px solid black;
  } */
</style>
